/**
 * Putting the service worker in place, and telling it when to let go of what it holds.
 *
 * Production only. In dev the bundle is served unhashed and rebuilt under you, and a worker
 * holding any of it is a worker serving yesterday's code — which is a whole afternoon lost to
 * wondering why an edit did nothing.
 */

/** The one worker, at the root so its scope is the whole app. */
const WORKER = '/sw.js'

export function registerServiceWorker(): void {
  if (import.meta.env.DEV || !('serviceWorker' in navigator)) {
    return
  }
  // After load: registering is not what somebody opened the app for, and the first paint is.
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register(WORKER).catch(() => {
      // A worker that will not register is not an error worth showing anybody. The app works
      // exactly as it did before there was one; it is only slower on the way back in.
    })
  })
}

/**
 * Signing out takes the pictures held on the device with it. They are held the way the session
 * token is, and a shared laptop where the next person can pull somebody's gym out of the cache
 * is not a thing to leave lying around.
 */
export function forgetHeldPictures(): void {
  if (!('serviceWorker' in navigator)) {
    return
  }
  navigator.serviceWorker.controller?.postMessage({ type: 'signed-out' })
}
